var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.06 11.88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m.8.07 9.98 5.4c.38.21.38.75 0 .96L.8 11.82c-.36.2-.8-.07-.8-.48V7.66c0-.25.17-.46.4-.52l4.47-1.19L.41 4.84A.546.546 0 0 1 0 4.31V.54C0 .13.44-.13.8.07"
  })));
};
export default SvgSend;